<template>
  <div>
    <NuxtLayout>
      <div class="text-center py-40">
        <h1 v-if="error.statusCode === 404">
          Sorry, we can't find that page and it might have recently moved.
        </h1>
        <h1 v-else>
          We're sorry, the page you're on caused an error. <br />
          Please try again or contact us online or at (800) 433-9570 (Mon-Fri 7am-6pm Central).
        </h1>
        <NuxtLink to="/static">
          You can click here to return to the home page
        </NuxtLink>
      </div>
    </NuxtLayout>
  </div>
</template>

<script>
export default {
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const { $auth: auth } = useNuxtApp();
    return auth;
  },
  data() {
    return {
      pageNotFound: 'Sorry, we can\'t find that page and it might have recently moved.',
      otherError: 'We\'re sorry, the page you\'re on caused an error. \nPlease try again or contact us online or at (800) 433-9570 (Mon-Fri 7am-6pm Central).',
    };
  },
  head() {
    console.log(`Error thrown: ${JSON.stringify(this.error)}`);
    // this is likely already being captured elsewhere and causing duplication
    // even if it isn't this will capture every single 404 that happens
    // it might just be crawlers/hackers trying random urls
    const title
      = this.error.statusCode === 404 ? this.pageNotFound : this.otherError;
    return {
      title,
    };
  },

  async mounted() {
    console.log('error layout mounted: ', this.error);
    if (this.error.statusCode === 401) {
      await this.auth.signOut({ redirect: false }).then(() => {
        this.$router.push('/login?authIssue=true');
      });
    }
  },
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
</style>
